import { API_UNAUTHORIZED_ERROR } from 'actions/api';
import {
  BOOTSTRAP_DASHBOARD_V3,
  BOOTSTRAP_DASHBOARD_V3_ERROR,
  BOOTSTRAP_DASHBOARD_V3_SUCCESS,
} from 'lib/constants/v3Actions';

const initialState = {
  initializationComplete: false,
  isUnauthorized: false,
  needsInitializing: true,
};

export default (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case BOOTSTRAP_DASHBOARD_V3:
      return { ...state, needsInitializing: false };
    case BOOTSTRAP_DASHBOARD_V3_ERROR:
      return { ...state, needsInitializing: true };
    case BOOTSTRAP_DASHBOARD_V3_SUCCESS:
      return { ...state, initializationComplete: true };
    case API_UNAUTHORIZED_ERROR:
      return { ...state, isUnauthorized: true };
    default:
      return state;
  }
};

export const isInitializationComplete = state => state.initializationComplete;
export const needsInitializing = state => state.needsInitializing;
export const isUnauthorized = state => state.isUnauthorized;
